"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function BecauseTrustDeservesVerification() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="because-trust-deserves-verification" ref={ref} className="relative w-full min-h-[90vh] flex flex-col lg:flex-row bg-background overflow-hidden">
      {}
      <div className="w-full lg:w-[60%] flex flex-col justify-center px-6 md:px-12 lg:px-24 py-16 lg:py-0 z-10">
        <div className={cn("transition-all duration-1000 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl leading-[1.1] md:leading-[1] text-foreground mt-6 mb-8 tracking-tight">Where trust is <br />strengthened by <br />clarity.<br /></h1>
          <p className="font-sans text-lg md:text-xl text-muted-foreground max-w-lg mb-10 leading-relaxed">We do the groundwork that most people overlook, so you don’t have to second-guess one of the biggest decisions of your life. <br />Because a decision that shapes your future should be made with complete understanding and confidence.</p>
          <div className="flex flex-col sm:flex-row gap-5 items-start sm:items-center">
            <Button asChild size="lg" className="h-14 px-8 text-base rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-0.5">
              <Link to="/GetClarityPage">Begin a Private Consultation</Link>
            </Button>
            <Button asChild variant="ghost" size="lg" className="h-14 px-6 text-base rounded-full hover:bg-secondary/50 text-foreground group">
              <Link to="/OurApproachPage">
                Learn Our Ethics
                <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="w-full lg:w-[40%] relative h-[500px] lg:h-auto p-4 lg:p-6 lg:pl-0">
        <div className={cn("w-full h-full rounded-2xl lg:rounded-3xl overflow-hidden relative shadow-2xl transition-all duration-1000 delay-300 ease-out transform", isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10")}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1554289/img/indian_couple_wedding_ceremony.png" alt="Indian couple during their wedding ceremony" className="w-full h-full object-cover object-center scale-105 hover:scale-100 transition-transform duration-[2s] ease-out" />
          {}
          <div className="absolute inset-0 bg-primary/5 mix-blend-multiply pointer-events-none" />
        </div>
      </div>
    </section>;
}